module.exports = __webpack_public_path__ + "static/media/email_clave.a4b84e70.svg";